import React from 'react';
import { Dispatch } from '@reduxjs/toolkit';

import { Event } from '../../../../interfaces/event/event.interface';

import { RemoveEventAction } from '../../../../actions/event/event.types';
import { EventActions } from '../../../../actions/event/event.actions';

import { useAppDispatch, useRemoval } from '../../../../hooks';

import { Modal } from '../../../../components/modal/Modal';
import { ModalLayout } from '../../../../components/modal/ModalLayout';
import RemoveModal from '../../../../components/modal/remove/RemoveModal';

const RemoveEventContainer = () => {
  const dispatch: Dispatch<RemoveEventAction> = useAppDispatch();

  const { element, showModal, setShowModal } = useRemoval();

  const onClose = () => setShowModal(false);

  const handleConfirm = (onComplete: () => void) => {
    dispatch(
      EventActions.removeEvent((element as Event).id as number, () => {
        onComplete();
        onClose();
      })
    );
  };

  return (
    <>
      {showModal && (
        <Modal>
          <ModalLayout onClose={onClose} title="Remove Event">
            <RemoveModal title={(element as Event).name} onConfirm={handleConfirm} />
          </ModalLayout>
        </Modal>
      )}
    </>
  );
};

export default RemoveEventContainer;
